// extracted by mini-css-extract-plugin
module.exports = {"tabbedEditor":"tabbedEditor--kCzDP","tabMenuContainer":"tabMenuContainer--3N2or","tabMenu":"tabMenu--3vlOb","wrapper":"wrapper--2wKPv"};